import { useCallback, useState } from "react";

export type ViewMode = "list" | "tiles";

const storageKey = (dataSourceId: string) => `${dataSourceId}_viewMode`;

/**
 * Remembers the chosen view per screen, the same way the grid persists its column
 * widths, so a user who prefers tiles does not have to switch on every visit.
 */
export function useViewMode(
  dataSourceId: string,
  enabled: boolean,
): [ViewMode, (mode: ViewMode) => void] {
  const [mode, setMode] = useState<ViewMode>(() => {
    const stored = localStorage.getItem(storageKey(dataSourceId));
    return stored === "tiles" ? "tiles" : "list";
  });

  const update = useCallback(
    (next: ViewMode) => {
      localStorage.setItem(storageKey(dataSourceId), next);
      setMode(next);
    },
    [dataSourceId],
  );

  // A stored preference must not strand the user on a view the screen no longer
  // offers, e.g. when the job stops declaring tileView.
  return [enabled ? mode : "list", update];
}
